import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const FMT = "YYYY-MM-DD";
export const UPCOMING_WINDOW_MONTHS = 3;
export const RECENT_WINDOW_DAYS = 30;

export const parseD = (v) => {
  if (!v) return dayjs(null);

  // handle [YYYY, MM, DD]
  if (Array.isArray(v) && v.length === 3) {
    const [y, m, d] = v;
    // use UTC to avoid TZ offset causing day -/+ 1
    return dayjs(new Date(Date.UTC(Number(y), Number(m) - 1, Number(d))));
  }

  // handle common string formats
  return dayjs(v, ["YYYY-MM-DD", "YYYY.MM.DD"], true);
};

export const fmtDE = (v) => {
  const d = parseD(v);
  return d.isValid() ? d.format("DD.MM.YYYY") : "-";
};

export const calcNextInspectionDate = (lastStr, freqYears) => {
  if (!lastStr || !freqYears || freqYears <= 0) return null;
  const last = parseD(lastStr);
  if (!last.isValid()) return null;
  return last.add(freqYears, "year").format(FMT);
};

export const getStatus = ({ nextStr, lastStr, protocolUploaded }) => {
  const today = dayjs().startOf("day");
  const next = parseD(nextStr);
  if (!next.isValid()) return "na";

  if (protocolUploaded) {
    const last = parseD(lastStr);
    if (last.isValid()) {
      const windowStart = next.subtract(RECENT_WINDOW_DAYS, "day");
      if (
        last.isSameOrAfter(windowStart, "day") &&
        last.isSameOrBefore(today, "day")
      ) {
        return "completed";
      }
    }
  }

  if (today.isAfter(next, "day")) return "overdue";

  const monthsUntilDue = next.diff(today, "month", true);
  if (monthsUntilDue <= UPCOMING_WINDOW_MONTHS) return "upcoming";

  return "completed";
};
